import script from "./RegisterSection.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterSection.vue?vue&type=script&setup=true&lang=js"

import "./RegisterSection.vue?vue&type=style&index=0&id=4e569fba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e569fba"]])

export default __exports__